import { render, staticRenderFns } from "./LocalePicker.vue?vue&type=template&id=0f1d784a&scoped=true"
import script from "./LocalePicker.vue?vue&type=script&lang=ts"
export * from "./LocalePicker.vue?vue&type=script&lang=ts"
import style0 from "./LocalePicker.vue?vue&type=style&index=0&id=0f1d784a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1d784a",
  null
  
)

export default component.exports